import { getToken, getToken2, getUser } from "../Utils/Common";
import { getAPICall, postAPICall } from "./axiosMethodCalls";
import form_data from "react-form-data";
import Moment from "moment";

//GET
export const getAllEmployees = async () => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "employees/get_all_employee",
      {
        requester: getUser(),
        token: getToken(),
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getAllEmployeesWOutPayroll = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "employees/get_employees_wo_payroll",
      {
        requester: getUser(),
        token: getToken(),
        employee_type: data.employee_type,
        date_from: data.date_from
          ? Moment(data.date_from).format("YYYY-MM-DD")
          : "",
        date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
        disbursement_date: data.disbursement_date
          ? Moment(data.disbursement_date).format("YYYY-MM-DD")
          : "",
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getEmployee = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "employees/get_employee",
      {
        requester: getUser(),
        token: getToken(),
        employee_id: id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const searchEmployee = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "employees/search",
      {
        requester: getUser(),
        token: getToken(),
        name: data.name,
        department: data.department,
        type: data.employee_type,
        status: data.status,
        page: data.page
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

//POST
export const createEmployee = async (employee, file) => {
  var allAttachments = employee.attachments.concat(file)
  let form_data = new FormData();
  form_data.append("requester", getUser());
  form_data.append("token", getToken());
  form_data.append("username", employee.username);
  form_data.append("password", employee.password);
  form_data.append("last_name", employee.last_name);
  form_data.append("first_name", employee.first_name);
  form_data.append("middle_name", employee.middle_name);
  form_data.append("suffix", employee.suffix);
  form_data.append("shift_id", employee.shift_id);
  form_data.append("email", employee.email);
  form_data.append("type", employee.type);
  form_data.append("department", employee.department);
  form_data.append("employee_type", employee.employee_type);
  form_data.append("contact_no", employee.contact_no);
  form_data.append("address", employee.address);
  form_data.append("gender", employee.gender);
  form_data.append("birthdate", employee.birthdate);
  form_data.append("civil_status", employee.civil_status);
  form_data.append("nationality", employee.nationality);
  form_data.append("religion", employee.religion);
  form_data.append("remarks", employee.remarks);
  form_data.append("payee_id_number", employee.payee_id_number);
  form_data.append("account_number", employee.account_number);
  form_data.append("sss", employee.sss);
  form_data.append("sss_loan", employee.sss_loan);
  form_data.append("pagibig", employee.pagibig);
  form_data.append("pagibig_loan", employee.pagibig_loan);
  form_data.append("philhealth", employee.philhealth);
  form_data.append("employment_status", employee.employment_status);
  form_data.append("salary_type", employee.salary_type);
  form_data.append("payroll_cycle", employee.payroll_cycle);
  form_data.append("salary", employee.salary);
  form_data.append("salary_per_day", employee.salary_per_day);

  form_data.append("educational_attainment", employee.educational_attainment ? employee.educational_attainment : "");
  form_data.append("medical_condition", employee.medical_condition ? employee.medical_condition : "");
  form_data.append("emergency_contact_name", employee.emergency_contact_name ? employee.emergency_contact_name : "");
  form_data.append("emergency_contact_no", employee.emergency_contact_no ? employee.emergency_contact_no : "");
  form_data.append("emergency_contact_relation", employee.emergency_contact_relation ? employee.emergency_contact_relation : "");
  form_data.append("pagibig_ref_no", employee.pagibig_ref_no ? employee.pagibig_ref_no : "");
  form_data.append("cedula_ref_no", employee.cedula_ref_no ? employee.cedula_ref_no : "");
  form_data.append("sss_ref_no", employee.sss_ref_no ? employee.sss_ref_no : "");
  form_data.append("tin_ref_no", employee.tin_ref_no ? employee.tin_ref_no : "");
  form_data.append("philhealth_ref_no", employee.philhealth_ref_no ? employee.philhealth_ref_no : "");
  form_data.append("pagibig_started_date", employee.pagibig_started_date ? employee.pagibig_started_date : "");
  form_data.append("cedula_started_date", employee.cedula_started_date ? employee.cedula_started_date : "");
  form_data.append("sss_started_date", employee.sss_started_date ? employee.sss_started_date : "");
  form_data.append("tin_started_date", employee.tin_started_date ? employee.tin_started_date : "");
  form_data.append("philhealth_started_date", employee.philhealth_started_date ? employee.philhealth_started_date : "");

  form_data.append(
    "transportation_allowance",
    employee.transportation_allowance
  );
  form_data.append("other_allowances", employee.other_allowances);
  form_data.append("rent", employee.rent);
  
  allAttachments.map((file) => {
      form_data.append(`attachments[]`, file, file.name);
      form_data.append(`file_type[]`, file.file_type);
      form_data.append('attachment_ids[]', null);
  })

  for (var pair of form_data.entries()) {
    
  }

  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "employees/create",
      form_data
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const updateEmployee = async (employee, file) => {
  var allAttachments = employee.attachments.concat(file)

  let form_data = new FormData();
  form_data.append("requester", getUser());
  form_data.append("token", getToken());
  // form_data.append("pin", employee.pin);
  form_data.append("employee_id", employee.id);
  form_data.append("username", employee.username ? employee.username : "");
  form_data.append("password", employee.password ? employee.password : "");
  form_data.append("last_name", employee.last_name);
  form_data.append("first_name", employee.first_name);
  form_data.append(
    "middle_name",
    employee.middle_name !== null ? employee.middle_name : ""
  );
  form_data.append("suffix", employee.suffix !== null ? employee.suffix : "");
  form_data.append("shift_id", employee.shift_id);
  form_data.append("email", employee.email);
  form_data.append("type", employee.type);
  form_data.append("status", employee.status);
  form_data.append("department", employee.department);
  form_data.append("employee_type", employee.employee_type);
  form_data.append("contact_no", employee.contact_no);
  form_data.append("address", employee.address);
  form_data.append("gender", employee.gender);
  form_data.append("birthdate", employee.birthdate);
  form_data.append("civil_status", employee.civil_status);
  form_data.append("nationality", employee.nationality);
  form_data.append("religion", employee.religion);
  form_data.append("remarks", employee.remarks ? employee.remarks : "");
  form_data.append(
    "payee_id_number",
    employee.payee_id_number ? employee.payee_id_number : ""
  );
  form_data.append(
    "account_number",
    employee.account_number ? employee.account_number : ""
  );
  form_data.append("sss", employee.sss);
  form_data.append("sss_loan", employee.sss_loan);
  form_data.append("pagibig", employee.pagibig);
  form_data.append("pagibig_loan", employee.pagibig_loan);
  form_data.append("philhealth", employee.philhealth);
  form_data.append("employment_status", employee.employment_status);
  form_data.append("salary_type", employee.salary_type);
  form_data.append("payroll_cycle", employee.payroll_cycle);
  form_data.append("salary", employee.salary);
  form_data.append("salary_per_day", employee.salary_per_day);
  form_data.append(
    "transportation_allowance",
    employee.transportation_allowance
  );
  form_data.append("other_allowances", employee.other_allowances);
  form_data.append("rent", employee.rent);

  form_data.append("educational_attainment", employee.educational_attainment ? employee.educational_attainment : "");
  form_data.append("medical_condition", employee.medical_condition ? employee.medical_condition : "");
  form_data.append("emergency_contact_name", employee.emergency_contact_name ? employee.emergency_contact_name : "");
  form_data.append("emergency_contact_no", employee.emergency_contact_no ? employee.emergency_contact_no : "");
  form_data.append("emergency_contact_relation", employee.emergency_contact_relation ? employee.emergency_contact_relation : "");
  form_data.append("pagibig_ref_no", employee.pagibig_ref_no ? employee.pagibig_ref_no : "");
  form_data.append("cedula_ref_no", employee.cedula_ref_no ? employee.cedula_ref_no : "");
  form_data.append("sss_ref_no", employee.sss_ref_no ? employee.sss_ref_no : "");
  form_data.append("tin_ref_no", employee.tin_ref_no ? employee.tin_ref_no : "");
  form_data.append("philhealth_ref_no", employee.philhealth_ref_no ? employee.philhealth_ref_no : "");
  form_data.append("pagibig_started_date", employee.pagibig_started_date ? employee.pagibig_started_date : "");
  form_data.append("cedula_started_date", employee.cedula_started_date ? employee.cedula_started_date : "");
  form_data.append("sss_started_date", employee.sss_started_date ? employee.sss_started_date : "");
  form_data.append("tin_started_date", employee.tin_started_date ? employee.tin_started_date : "");
  form_data.append("philhealth_started_date", employee.philhealth_started_date ? employee.philhealth_started_date : "");

  allAttachments.map((file) => {
      form_data.append('attachments[]', file, file.name);
      form_data.append(`file_type[]`, file.file_type);
      form_data.append('attachment_ids[]', null);
  });
  employee.prev_files.map((file) => {
      form_data.append('attachment_ids[]', file.id);
  });
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "employees/update",
      form_data
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteEmployee = async (pin) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "employees/delete",
      {
        requester: getUser(),
        token: getToken(),
        pin: pin,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

// export const changeEmployeeStatus = async (id, status) => {
//     try {
//         const response = await postAPICall(process.env.REACT_APP_LINK + "employees/change_status", {
//             requester: getUser(),
//             token: getToken(),
//             employee_id: id,
//             status: status
//         })
//         return { data: response.data }
//     } catch (error) {
//         return { error: error.response }
//     }
// }
// -----------------POTATO-------------------
//GET
export const getAllEmployeesPotato = async () => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_POTATO + "employees/get_all_employee",
      {
        requester: getUser(),
        token: getToken2(),
      }, "potato"
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createEmployeePotato = async (employee, file, pin) => {
  let form_data = new FormData();
  form_data.append("requester", getUser());
  form_data.append("token", getToken2());
  form_data.append("username", employee.username);
  form_data.append("password", employee.password);
  form_data.append("last_name", employee.last_name);
  form_data.append("first_name", employee.first_name);
  form_data.append("middle_name", employee.middle_name);
  form_data.append("suffix", employee.suffix);
  form_data.append("email", employee.email);
  form_data.append("type", employee.type);
  form_data.append("department", employee.department);
  form_data.append("employee_type", employee.employee_type);
  form_data.append("contact_no", employee.contact_no);
  form_data.append("address", employee.address);
  form_data.append("gender", employee.gender);
  form_data.append("birthdate", employee.birthdate);
  form_data.append("civil_status", employee.civil_status);
  form_data.append("nationality", employee.nationality);
  form_data.append("religion", employee.religion);
  form_data.append("remarks", employee.remarks);
  form_data.append("payee_id_number", employee.payee_id_number);
  form_data.append("account_number", employee.account_number);
  form_data.append("sss", employee.sss);
  form_data.append("sss_loan", employee.sss_loan);
  form_data.append("pagibig", employee.pagibig);
  form_data.append("pagibig_loan", employee.pagibig_loan);
  form_data.append("philhealth", employee.philhealth);
  form_data.append("employment_status", employee.employment_status);
  form_data.append("salary_type", employee.salary_type);
  form_data.append("payroll_cycle", employee.payroll_cycle);
  form_data.append("salary", employee.salary);
  form_data.append("salary_per_day", employee.salary_per_day);
  form_data.append(
    "transportation_allowance",
    employee.transportation_allowance
  );
  form_data.append("other_allowances", employee.other_allowances);
  form_data.append("rent", employee.rent);
  form_data.append("profile_picture", file);
  form_data.append("pin", pin);

  for (var pair of form_data.entries()) {
    
  }

  try {
    const response = await postAPICall(
      process.env.REACT_APP_POTATO + "employees/create",
      form_data, "potato"
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};


export const updateEmployeePotato = async (employee, file) => {
  let form_data = new FormData();
  form_data.append("requester", getUser());
  form_data.append("token", getToken2());
  // form_data.append("employee_id", employee.id);
  form_data.append("pin", employee.pin);
  form_data.append("username", employee.username ? employee.username : "");
  form_data.append("password", employee.password ? employee.password : "");
  form_data.append("last_name", employee.last_name);
  form_data.append("first_name", employee.first_name);
  form_data.append(
    "middle_name",
    employee.middle_name !== null ? employee.middle_name : ""
  );
  form_data.append("suffix", employee.suffix !== null ? employee.suffix : "");
  form_data.append("email", employee.email);
  form_data.append("type", employee.type);
  form_data.append("status", employee.status);
  form_data.append("department", employee.department);
  form_data.append("employee_type", employee.employee_type);
  form_data.append("contact_no", employee.contact_no);
  form_data.append("address", employee.address);
  form_data.append("gender", employee.gender);
  form_data.append("birthdate", employee.birthdate);
  form_data.append("civil_status", employee.civil_status);
  form_data.append("nationality", employee.nationality);
  form_data.append("religion", employee.religion);
  form_data.append("remarks", employee.remarks ? employee.remarks : "");
  form_data.append(
    "payee_id_number",
    employee.payee_id_number ? employee.payee_id_number : ""
  );
  form_data.append(
    "account_number",
    employee.account_number ? employee.account_number : ""
  );
  form_data.append("sss", employee.sss);
  form_data.append("sss_loan", employee.sss_loan);
  form_data.append("pagibig", employee.pagibig);
  form_data.append("pagibig_loan", employee.pagibig_loan);
  form_data.append("philhealth", employee.philhealth);
  form_data.append("employment_status", employee.employment_status);
  form_data.append("salary_type", employee.salary_type);
  form_data.append("payroll_cycle", employee.payroll_cycle);
  form_data.append("salary", employee.salary);
  form_data.append("salary_per_day", employee.salary_per_day);
  form_data.append(
    "transportation_allowance",
    employee.transportation_allowance
  );
  form_data.append("other_allowances", employee.other_allowances);
  form_data.append("rent", employee.rent);
  file.name !== undefined && form_data.append("profile_picture", file);

  for (var pair of form_data.entries()) {
    
  }
  try {
    const response = await postAPICall(
      process.env.REACT_APP_POTATO + "employees/update",
      form_data, "potato"
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteEmployeePotato = async (pin) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_POTATO + "employees/delete",
      {
        requester: getUser(),
        token: getToken2(),
        pin: pin,
      }, "potato"
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
